<mat-card *ngIf="invoicingData && invoicingData.projectData">
     <mat-toolbar style="width:100%" color="secondary">
      <span style="float: left;clear: left;width:80%">
          {{(invoicingData.projectData.titol | slice:0:100)+"..."}}</span>
      <div style="float: left;clear: left;width:20%">
        <button mat-icon-button style="float: right; margin-right:0" (click)="close()" matTooltip="{{ 'common.tancar' | translate }}" attr.aria-label="{{ 'common.tancar' | translate }}" matTooltipClass="tooltip-style" >
          <mat-icon color="primary" style="font-size:24px">close</mat-icon>
        </button>
        <button mat-icon-button matTooltip="{{ 'facturacio.toolbar.exportarToolTip' | translate }}" attr.aria-label="{{ 'facturacio.toolbar.exportarToolTip' | translate }}" matTooltipClass="tooltip-style" (click)="this.export()" style="float: right; margin-left:10px;margin-right: 0">
           <mat-icon color="primary">assignment_returned</mat-icon>
        </button>
        <button mat-icon-button (click)="addInvoice()" color="primary" matTooltip="{{ 'facturacio.toolbar.afegirToolTip' | translate }}" attr.aria-label="{{ 'facturacio.toolbar.afegirToolTip' | translate }}" matTooltipClass="tooltip-style" style="float: right; margin-left:10px;margin-right: 0">
           <mat-icon>note_add</mat-icon>
        </button>
     </div>
    </mat-toolbar>
    <mat-progress-bar mode="indeterminate" color="warm" *ngIf="showAsyncProgress" style="position: absolute;"></mat-progress-bar>
    <mat-card-content style="padding: 24px;height: 400px;overflow-y: auto">
      <h2 mat-line>{{ 'facturacio.titolDadesTreball' | translate }}</h2>
      <div class="dades-pressupost-import" style="background-color: #DDDDDD;padding:24px">
        <mat-form-field style="width: 80%">
         <input matInput placeholder="{{ 'facturacio.camps.nom' | translate }}" name="clau" disabled
        [value]="invoicingData.projectData.codi"
       />
        </mat-form-field> 
        <mat-form-field style="width: 15%;min-width:200px">
         <input matInput placeholder="{{ 'facturacio.camps.empresa' | translate }}" name="empresa" disabled
        [value]="invoicingData.projectData.empresa"
       />
        </mat-form-field> 
        <mat-form-field style="width: 100px">
         <input matInput placeholder="{{ 'facturacio.camps.pressupostTotal' | translate }}" name="pressupostTotal" disabled
          [value]="invoicingData.projectData.pressupostTotal | number:'1.0-2'"
         />
        </mat-form-field> 
        <mat-form-field style="width: 140px">
         <input matInput placeholder="{{ 'facturacio.camps.pressupostContractat' | translate }}" name="pressupostContractat" disabled
          [value]="invoicingData.projectData.pressupostContractat | number:'1.0-2'"
         />
        </mat-form-field> 
        <mat-form-field style="width: 100px">
         <input matInput placeholder="{{ 'facturacio.camps.impostos' | translate }}" name="importImpostos" disabled
          [value]="invoicingData.projectData.importImpostos | number:'1.0-2'"
         />
        </mat-form-field> 
        <mat-form-field style="width: 100px">
         <input matInput placeholder="{{ 'facturacio.camps.garantia' | translate }}" name="importGarantia" disabled
          [value]="invoicingData.projectData.pressupostGarantia | number:'1.0-2'"
         />
        </mat-form-field> 
      </div>
    <h2 mat-line style="padding-top:10px">{{ 'facturacio.titolFacturacio' | translate }}</h2>
    <mat-form-field>
       <input matInput placeholder="{{ 'facturacio.acumulatFacturat' | translate }}" name="acumulatFacturat" disabled
          [value]="acumulat.facturat | number:'1.0-2'"
        />
    </mat-form-field>
    <mat-form-field>
     <input matInput placeholder="{{ 'invoicesSummary.acumulatCobrat' | translate }}" name="acumulatCobrat" disabled
         [value]="acumulat.cobrat | number:'1.0-2'"
        />
    </mat-form-field>

    <mat-table style="overflow-y: auto;height:200px;width:100%" [dataSource]="invoicingData.invoices">
      <ng-container matColumnDef="numero_factura">
        <div style="width:7%" *matHeaderCellDef>&nbsp;{{ 'facturacio.taula.colNumero' | translate }}</div>
        <div style="width:7%" *matCellDef="let element"> {{element.numero_factura}} </div>
      </ng-container>

      <ng-container matColumnDef="data_factura" attr.title="{{ 'facturacio.titleDataFactura' | translate }}">
        <div style="width:12%" *matHeaderCellDef>{{ 'facturacio.taula.colDataFactura' | translate }}</div>
        <div style="width:12%" *matCellDef="let element">
          <span style="color:#FF0000" *ngIf="!element.data_factura">{{element.data_factura_prevista | date}} </span>
          <span *ngIf="element.data_factura">{{element.data_factura | date}} </span>
        </div>
      </ng-container>

      <ng-container matColumnDef="data_cobrament">
        <div style="width:12%" *matHeaderCellDef>{{ 'facturacio.taula.colDataCobrament' | translate }}</div>
        <div style="width:12%" *matCellDef="let element">
           <span style="color:#FF0000" *ngIf="!element.data_cobrament">{{element.data_cobrament_prevista | date}}</span>
          <span *ngIf="element.data_cobrament">{{element.data_cobrament | date}} </span> 
        </div>
      </ng-container>

      <ng-container matColumnDef="facturacio_prevista_eur">
        <div style="width:12%" *matHeaderCellDef>{{ 'facturacio.taula.colFacturacioEur' | translate }}</div>
        <div style="width:12%" *matCellDef="let element"> {{element.facturacio_prevista_eur | number:'1.0-2'}} </div>
      </ng-container>

      <ng-container matColumnDef="facturacio_prevista_loc">
        <div style="width:12%" *matHeaderCellDef>{{ 'invoicesSummary.colFacturacioLoc' | translate }}</div>
        <div style="width:12%" *matCellDef="let element"> {{element.facturacio_prevista_loc | number:'1.0-2'}} </div>
      </ng-container>

      <ng-container matColumnDef="facturacio_prevista_percent">
        <div style="width:12%" *matHeaderCellDef>{{ 'facturacio.taula.colPercentPressupost' | translate }}</div>
        <div style="width:12%" *matCellDef="let element"> {{element.facturacio_prevista_percent | number:'1.0-2'}} </div>
      </ng-container>

      <ng-container matColumnDef="activa">
        <div style="width:8%" *matHeaderCellDef>{{ 'facturacio.taula.colActiva' | translate }}</div>
        <div style="width:8%" *matCellDef="let element">
          <mat-checkbox style="margin-right: 1em;" [checked]="element.activa"></mat-checkbox>
        </div>
      </ng-container>

      <ng-container matColumnDef="facturar">
        <div style="width:8%" *matHeaderCellDef>{{ 'invoicesSummary.colFacturar' | translate }}</div>
        <div style="width:8%" *matCellDef="let element">
          <mat-checkbox style="margin-right: 1em;" [checked]="element.facturar"></mat-checkbox>
        </div>
      </ng-container>

      <ng-container matColumnDef="observacions">
        <div style="width:13%" *matHeaderCellDef>{{ 'facturacio.taula.colObservacions' | translate }}</div>
        <div style="width:13%" *matCellDef="let element"> {{element.observacions}} </div>
      </ng-container>

      <ng-container matColumnDef="accio">
        <div style="width:10%" *matHeaderCellDef>{{ 'invoicesSummary.colAccio' | translate }}</div>
        <div style="width:10%" *matCellDef="let element">
            <button mat-icon-button title="{{ 'facturacio.editarTitle' | translate }}" color="primary" 
              (click)="editInvoice(element)" style="margin-right:-15px">
              <mat-icon>mode_edit</mat-icon>
            </button>
            <button mat-icon-button title="{{ 'facturacio.esborrarTitle' | translate }}" color="primary" 
              (click)="deleteInvoice(element)" style="margin-right:-15px">
              <mat-icon>delete_forever</mat-icon>
            </button>
        </div>
      </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

    </mat-table>
   </mat-card-content>
</mat-card>
